import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttractLoopPopupComponent } from './attract-loop-popup/attract-loop-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTimePickerModule } from '../../../common/components/datetimepicker/datetimepicker-popover/datetimepicker.module';
import { DateTimeZoneModule } from '../../../common/components/date-time-zone/date-time-zone.component/date-time-zone.module';


@NgModule({
  declarations: [
    AttractLoopPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DateTimePickerModule,
    DateTimeZoneModule
  ],
  exports: [AttractLoopPopupComponent]
})
export class AttractLoopPopupModule { }
